import http from "./http";

export function getTimeline({ module_name, module_id, page }) {
  return http.get(`timeline/details?page=${page}`, {
    params: { module_name, module_id },
  });
}
